<template>
  <div class="cb_device-list _boxBg_dark_big absolute_center">
    <div class="title">闭环管理组织架构图</div>
    <div class="selfClose_btn" @click="close"></div>
    <div class="carbon-emission">
      <div class="carbon-emission-center block-bg-box" ref="imgBoxEl">
        <img
          :src="selectItem.value"
          alt=""
          class="imgIcon"
          ref="imgEl"
          @load="loadSucess"
        />
      </div>
    </div>
    <!-- tab切换 -->
    <div class="tab-box">
      <div class="content-box">
        <div
          :class="{ item: true, item_selct: item.label === selectItem.label }"
          v-for="(item, index) in itemList"
          :key="item.label"
          @click="selectItemFun(item, index)"
        >
          {{ item.label }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import architectureImg1 from "@/modules/cloaeLoopMonitor/img/architectureImg1.jpeg";
import architectureImg2 from "@/modules/cloaeLoopMonitor/img/architectureImg2.jpeg";
import architectureImg3 from "@/modules/cloaeLoopMonitor/img/architectureImg3.jpeg";
import architectureImg4 from "@/modules/cloaeLoopMonitor/img/architectureImg4.jpeg";
import architectureImg5 from "@/modules/cloaeLoopMonitor/img/architectureImg5.jpeg";
import architectureImg6 from "@/modules/cloaeLoopMonitor/img/architectureImg6.jpeg";

export default {
  props: {},
  data() {
    //这里存放数据
    return {
      customerId: this.$store.state.customerId,
      isShowContent: false,
      itemList: [
        {
          label: "发电厂闭环管理组织架构图",
          value: architectureImg1,
          link: 'https://visimg.bmetech.com/RFGTBHGLIMG/fdc.jpeg',
          gap: 80,
        },
        {
          label: "炼钢闭环管理组织架构图",
          value: architectureImg2,
          link: 'https://visimg.bmetech.com/RFGTBHGLIMG/lgc.jpeg',
          gap: 1500,
        },
        {
          label: "炼铁厂闭环管理组织架构图",
          value: architectureImg3,
          link: 'https://visimg.bmetech.com/RFGTBHGLIMG/ltc.jpeg',
          gap: 100,
        },
        {
          label: "烧结厂闭环管理组织架构图",
          value: architectureImg4,
          link: 'https://visimg.bmetech.com/RFGTBHGLIMG/sjc.jpeg',
          gap: -280,
        },
        {
          label: "轧钢厂闭环管理组织架构图",
          value: architectureImg5,
          link: 'https://visimg.bmetech.com/RFGTBHGLIMG/zgc.jpeg',
          gap: 300,
        },
        {
          label: "原料厂闭环管理组织架构图",
          value: architectureImg6,
          link: 'https://visimg.bmetech.com/RFGTBHGLIMG/ylc.jpeg',
          gap: 100,
        },
      ],
      gap: 80,
      selectItem: {
        label: "发电厂闭环管理组织架构图",
        value: architectureImg1,
      },
    };
  },
  //计算属性 类似于data概念
  computed: {},
  mounted() {},
  //方法集合
  methods: {
    close() {
      let that = this._.appContext.app;
      this.$popup.close3(that);
    },
    /**
     * 将组件展示图片的初始位置设置为图片的正中间
     * 有点问题，这个的是适配 transform 的 scale(1)的情况。
     */
    setImgPosition() {
      this.$refs.imgBoxEl.scrollTo({
        top:
          (parseInt(window.getComputedStyle(this.$refs.imgEl).height) / 2 -
            parseInt(window.getComputedStyle(this.$refs.imgBoxEl).height) / 2) * parseFloat(this.$store.state.scaleValue) + 
          this.gap / parseFloat(this.$store.state.scaleValue),
        left: 0,
        behavior: "smooth",
      });
    },
    /**
     * @param item 每一项
     * @param index 下标
     * @return void
     */
    selectItemFun(item, index) {
      this.selectItem = item;
      this.gap = item.gap;
    },
    loadSucess() {
      this.setImgPosition();
    },
  },
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="scss">
.close-loop-monitor {
  left: 50% !important;
}
</style>
<style lang="scss" scoped="scoped">
._boxBg_dark_big {
  width: 2950px;
  height: auto;
}

.cb_device-list {
  position: relative;
  .title {
    font-size: 28px;
    color: #f5a623;
    border-bottom: solid 3px #f5a623;
    padding: 0 100px;
    line-height: 60px;
    display: inline-block;
    position: absolute;
    left: 50%;
    transform: translate(-50%);
    top: 0;
    font-weight: 500;
  }
  .tab-box {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 60px;
    background: rgba(38, 58, 66, 0);
    .content-box {
      width: 100%;
      height: 60px;
      display: flex;
      align-items: center;
      justify-content: space-evenly;
      background: rgba(38, 58, 66, 0.5);
      .item {
        color: #fff;
        font-size: 25px;
        line-height: 40px;
        cursor: pointer;
      }
      .item:hover {
        color: #f5a623;
      }
      .item_selct {
        color: #f5a623;
      }
    }
  }
}

.selected {
  background: linear-gradient(
    180deg,
    rgba(108, 151, 255, 0.2) 0%,
    rgba(107, 151, 255, 0.2) 48%,
    rgba(58, 116, 255, 0.1) 100%,
    #0049fa 100%,
    #0049fa 100%
  );
  border: 2px solid #4be0ff;
}

.center-block {
  position: relative;
  @include bg-box(2810px, 730px, "panelView_blackBg_3_3.png");
  padding: 20px;
}

.carbon-emission-center {
  //   width: auto !important;
  width: 100%;
  overflow: auto;
  margin-top: 10px;
  height: 770px;
  // padding: 0 200px;
  box-sizing: border-box;
  img {
    // height: 1350px;
    // width: 100%;
  }
  &::-webkit-scrollbar {
    height: 8px;
    width: 8px;
  }
  /* 滚动条滑块 */
  &::-webkit-scrollbar-thumb {
    width: 8px;
    height: 258px;
    background: linear-gradient(180deg, #449eff 0%, #1e5cbb 100%);
    box-shadow: 2px 2px 4px 0px rgba(0, 36, 32, 0.5);
    border-radius: 4px;
  }
}

.carbon-emission {
  padding-top: 90px;
  display: flex;
  &-center {
    width: 100%;
    margin: 0 20px;
    box-sizing: border-box;
  }
  .flex {
    display: flex;
  }
  .mb-10 {
    margin-bottom: 10px;
  }
  .mr-20 {
    margin-right: 20px;
  }
  .w-50 {
    width: 50%;
  }
  .w-30 {
    width: 30%;
    height: 76px;
    background: linear-gradient(
      180deg,
      rgba(108, 151, 255, 0.2) 0%,
      rgba(107, 151, 255, 0.2) 48%,
      rgba(58, 116, 255, 0.1) 100%,
      #0049fa 100%,
      #0049fa 100%
    );
    border: 1px solid rgba(38, 76, 169, 0.53);
    filter: blur(8px);
    color: #9fbafd;
    line-height: 76px;
    text-align: center;
    font-size: 16px;
  }
  .w-30_font {
    width: 30%;
    height: 76px;
    color: #9fbafd;
    line-height: 76px;
    text-align: center;
    font-size: 16px;
  }
  .w-70 {
    width: 70%;
    height: 76px;
    background: linear-gradient(
      180deg,
      rgba(108, 151, 255, 0.2) 0%,
      rgba(107, 151, 255, 0.2) 48%,
      rgba(58, 116, 255, 0.1) 100%,
      #0049fa 100%,
      #0049fa 100%
    );
    border: 1px solid rgba(38, 76, 169, 0.53);
    filter: blur(8px);
    opacity: 0.5;
    color: #9fbafd;
    line-height: 76px;
    text-align: center;
    font-size: 16px;
  }
  .w-70_font {
    width: 70%;
    height: 76px;
    color: #9fbafd;
    line-height: 76px;
    text-align: center;
    font-size: 16px;
  }
  .block-bg {
    background: linear-gradient(#111828, #080e1b);
  }
  .block-bg-box {
    //@include bg-box(600px, 250px, 'panelView_blackBg_4_3.png');
    .imgIcon {
      margin: auto;
    }
  }
}
</style>